import React, { Component } from 'react';
import update from 'react-addons-update';
import quizQuestions from './data/quizQuestions';
import Quiz from './components/Quiz';
import Result from './components/Result';
import gclogo from './svg/gclogo.svg';
import './App.css';
var uuid = require('uuid');

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id:uuid.v1(),
      name: '',
      email: '',
      consent: true,
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      answersCount: {
        Administration: 0,
        Apostleship: 0,
        'Artistic Expression': 0,
        Craftsmanship: 0,
        Discernment: 0,
        Evangelism: 0,
        Exhortation: 0,
        Faith: 0,
        Giving: 0,
        Helps: 0,
        Hospitality: 0,
        Intercession: 0,
        Knowledge: 0,
        Leadership: 0,
        Mercy: 0,
        Prophecy: 0,
        Shepherding: 0,
        Teaching: 0,
        Wisdom: 0,
        Healing: 0,
        'Miraculous Powers': 0,
        Tongues: 0,
        'Interpretation of Tongues': 0
      },
      results: []
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const shuffledAnswerOptions = quizQuestions.map((question) => this.shuffleArray(question.answers));
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: shuffledAnswerOptions[0]
    });
  }

  shuffleArray(array) {
    //TODO: get rid of this shuffling
    return array;
  };

  handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);

    if (this.state.questionId < quizQuestions.length) {
        setTimeout(() => this.setNextQuestion(), 300);
    } else {
        setTimeout(() => this.setResults(this.getResults()), 300);
    }
  }

  handleSubmit(event) {
    this.setState({
        name: this.refs.name.value,
        email: this.refs.email.value,
        consent: this.refs.consent.checked
    });
    event.preventDefault();
  }

  setUserAnswer(answer) {
    const answerParts = answer.split('|');
    const type = answerParts[0];
    const value = Number(answerParts[1]);
    const updatedAnswersCount = update(this.state.answersCount, {
      [type]: {$apply: (currentValue) => currentValue + value}
    });

    this.setState({
        answersCount: updatedAnswersCount,
        answer: answer
    });
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;

    this.setState({
        counter: counter,
        questionId: questionId,
        question: quizQuestions[counter].question,
        answerOptions: quizQuestions[counter].answers,
        answer: ''
    });
  }

  getResults() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    answersCountKeys.sort(function(a, b) { return answersCount[b] - answersCount[a] });
    const sortedResults = answersCountKeys.map(gift => gift + ": " + answersCount[gift]);
    return sortedResults;
  }

  setResults(results) {
    this.setState({ results: results });

    fetch('/api/survey', {
      method: 'post',
      headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        consent: this.state.consent,
        results: this.state.results
      })
  });
  }

  renderLogin() {
    return (
      <div className="welcome-page">
        <p>Welcome to the Grace Commons Church Spiritual Gifts Assessment!  We 
          hope it will be helpful as you seek to discover more of how God has uniquely 
          designed you.</p>
        <p>You'll notice that once you answer a question, you are automatically 
          presented with the next one with no opportunity to change your answer.  This 
          is deliberate, as we believe it's better not to overthink your answers.  Just 
          go with your first intuition.</p>
        <p>When you finish the assessment, if you are affiliated with Grace Commons Church
           (member, visitor, volunteer, etc.) and give your consent below, your results will be 
          stored in a confidential database accessible only to church staff and ministry 
          leaders.  This database is used to help connect people with suitable ministry 
          opportunities.</p>
        <p>Entering your name and email address is completely optional.  We value your privacy, 
          and will never sell your email address or share it outside the church community.  
          If you do provide an email address, you will receive an 
          email containing your results from youruniquedesign@gmail.com. If you don't 
          see an email from us within a couple of hours, please check your Spam folder.</p>
        <p>Let's get started!</p>
        <form onSubmit={this.handleSubmit}>
          <input type="text" placeholder="Enter your name" ref="name" />
          <br /><br />
          <input type="text" placeholder="Enter your email address (optional)" ref="email" />
          <br /><br />
          <fieldset>
            <input type="checkbox" id="consent" name="consentCheck" ref="consent" checked />
            <label>I am affiliated with Grace Commons Church, and I 
            give consent for my assessment results to be added to the church database.
            </label>
          </fieldset>
          <br /><br />
          <input type="submit" value="Submit" />
        </form>
        <h4>Selected resources for further study:</h4>
          <p><b>Scripture:</b></p>
          <p>Read 1 Corinthians 12, Romans 12, Ephesians 4, 1 Peter 4</p>
          <p><b>Books and Study Guides:</b></p>
          <ul>
            <li><a href="https://www.amazon.com/God-Gifts-You-Unique-Calling/dp/0692911634/ref=sr_1_1"><i>God. Gifts. You. Your Unique Calling and Design (workbook/study guide)</i> by Shirley Giles Davis</a></li>
            <li><a href="https://www.amazon.com/Your-Unique-Design-Class-Guide/dp/0578590190/ref=sr_1_1"><i>Your Unique Design Class Guide</i> by Shirley Giles Davis</a></li>
            <li><i>Your Unique Design Facilitator Guide</i> by Shirley Giles Davis</li>
            <li><i>Unfinished Business: Returning the Ministry to the People of God</i> by Greg Ogden</li>
            <li><i>The Equipping Church</i> by Sue Mallory</li>
          </ul>
      </div>
    );
  }

  renderQuiz() {
    return (
      <Quiz
        answer={this.state.answer}
        answerOptions={this.state.answerOptions}
        questionId={this.state.questionId}
        question={this.state.question}
        questionTotal={quizQuestions.length}
        onAnswerSelected={this.handleAnswerSelected}
      />
    );
  }

  renderResult() {
    return (
      <Result quizResult={this.state.results} />
    );
  }

  renderPage() {
    if (this.state.name.length < 1) {
      return this.renderLogin();
    } else if (this.state.results.length > 0) {
      return this.renderResult();
    } else {
      return this.renderQuiz();
    }
  }

  render() {
    var content = this.renderPage();
    return (
      <div className="App">
        <div className="App-header">
          <img src={gclogo} alt="logo" />
          <h2>Grace Commons Church Spiritual Gifts Assessment</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js